import { Ng2StateDeclaration } from '@uirouter/angular';
import { BaseStateComponent } from '@layout/base-state.component';
import { CrawlQueueComponent } from '@monsido/pages/admin/crawl-queue/crawl-queue.component';

export const CRAWL_QUEUE_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.admin.crawl_queue',
        url: '/crawl_queue',
        abstract: true,
        component: BaseStateComponent,
    },
    {
        name: 'base.admin.crawl_queue.index',
        url: '?search',
        views: {
            '^.^.^.$default': {
                component: CrawlQueueComponent,
            },
        },
        dynamic: true,
    },
];
